/* #*/ export const PERSON = `
name:
  first: Daniel
  middle:
  last: Chote
about: I am a full stack developer and seasoned manager. I have been in senior leadership positions for more than 10 years. I enjoy empowering engineers to focus on their careers, I love an infrastructure challenge, and I like to get my hands dirty in code.
position: Integration Expert

birth:
  year: 1981
  location: Hastings, New Zealand

experience:
- company: Videon
  position: VP of Engineering
  timeperiod: April 2021 - Current
  skills:
    - name: Project Management
    - name: IT Management
    - name: HR Initiatives
    - name: VueJS
    - name: Python
    - name: AWS CDK
    - name: Linux (Ubuntu/OpenEmbedded)
    - name: Android
    - name: Hardware Design Review
    - name: FPGA
    - name: Low Latency Video Streaming
    - name: Video Encoding / Muxing
  description: I was convinced to join an established company going through a startup re-birth to help drive the engineering team and release some new products. 
               We optimized the engineering processes by streamlining communication channels and adding clear acceptance criteria to tasks. I introduced the company to Docker, and we launched a video compute platform based on it. 
               I led a small team that developed and launched a device management platform in less than 1 year (I also did 100% of the frontend work in VueJS). We developed a new hardware video compute platform for next-generation video workloads.
    
- company: GoDaddy
  position: Director of Engineering (Domains)
  timeperiod: March 2019 - April 2021
  skills: 
    - name: SRE Management
    - name: Linux (CentOS)
    - name: Infrastructure
    - name: AWS
    - name: Prometheus/Grafana
    - name: Site24x7
    - name: ServiceNow
    - name: VueJS
    - name: Python
    - name: Microsoft SQL Server
    - name: Compliance
    - name: ISO27001
  description: I led a production engineering team to help teams migrate legacy on-prem infrastructure to AWS. We engaged in all the crisis response and compliance initiatives. 
               We helped aggregate/standardize internal infrastructure health metrics. I learned a lot about SRE in a large organization!
    
- company: Filament
  position: Infrastructure Engineer
  timeperiod: April 2018 - March 2019
  skills:
  - name: Linux (Debian/Ubuntu)
  - name: Infrastructure
  - name: Kubernetes
  - name: Private Etherium
  - name: BigChainDB
  - name: Hyperledger Sawtooth
  - name: Python
  - name: golang
  - name: C
  - name: Javascript
  - name: Embedded systems
  - name: particle.io
  - name: Raspberry Pi
  - name: Dell EMC
  - name: VMWare
  - name: Prometheus/Grafana
  description: I focused on production worthiness of various private blockchain stacks and how to integrate secure elements in to embedded systems.  
               We worked on a multi-datacenter blockchain service solution that emphasized high-availability while providing a reusable software stack across a wide range of edge hardware platforms.  
               This work involved building a fault tolerant Kubernetes bare metal infrastructure, as well as exploring bridging to cloud providers such as Azure, AWS, and GCE.
  
- company: Helping Hands of America
  position: CTO
  timeperiod: June 2017 - Present
  skills:
  - name: Project Management
  - name: Google GSuite
  - name: Google Adwords
  - name: PHP
  - name: MySQL
  - name: Linux (Debian)
  - name: OnSIP
  - name: Linode
  - name: Hubspot
  - name: CallRail
  description: I redesigned the company website to focus on mobile-friendly content and to present clearer calls to action to help increase conversion of users.  
               I consolidated the infrastructure, including various online services, to reduce monthly expenses.
               In conjunction with Google Adwords I integrated Hubspot, OnSIP, and CallRail to optimize the sales pipeline and track campaign performance more effectively.

- company: BrandYourself, Inc.
  position: CTO
  timeperiod: March 2011 - June 2017
  skills:
  - name: Project Management
  - name: Caffe
  - name: py-faster-rcnn
  - name: Gearman
  - name: Redis
  - name: Beanstalkd
  - name: LDAP
  - name: PHP
  - name: MySQL
  - name: Linux (Debian)
  - name: Postfix
  - name: Sendgrid
  - name: Braintree
  - name: Nagios + Cacti
  - name: heartbeat
  - name: IPTables
  - name: Asterisk PBX
  - name: OnSIP
  - name: Linode
  description: I managed the team of developers through multiple versions of the product with successful launches each time. 
               I was the initial designer of the PHP framework used to build the first few versions of the product.
               We employed deep learning technologies for object recognition in photos as well as sentiment analysis for text. 
               My focus was on using faster-rcnn and training the model using an in house image annotation tool.  
               I designed and built a low cost GPU server configuration to aide the initial deployment of deep learning for production without a substantial financial commitment.

- company: Double Dutch Studios
  position: Technical Cofounder & Vice President of Engineering
  timeperiod: September 2010 - Jan 2011
  skills:
  - name: Project Management
  - name: PHP
  - name: MySQL
  - name: Google API
  - name: OAuth/OpenID
  description: Sole developer on an initial alpha product for inSparq. Developed in PHP, using Google APIs with OAuth/OpenID.

- company: Match.com
  position: Director of Software Development (singlesnet.com)
  timeperiod: March 2010 - Sept 2010
  skills:
  - name: Project Management
  - name: PHP
  - name: MySQL
  - name: ORM / Reporting
  - name: Asterisk PBX
  - name: Linux (Debian)
  description: After the sale of Singlesnet.com to Match.com I moved from CTO to Director of Software Development and helped transition the company knowledge to the new management team.
  
- company: Singlesnet.com
  position: CTO
  timeperiod: January 2009 - September 2010
  skills:
  - name: Project Management
  - name: PPC advertising
  - name: PHP
  - name: MySQL
  - name: Linux (Debian)
  - name: C/C++
  - name: Objective-C
  - name: Shell scripting / dsh
  - name: Postfix
  - name: LDAP
  - name: Nagios + Cacti
  - name: heartbeat
  - name: IPTables
  - name: F5 Networks BigIP
  - name: Isilon Clustering
  - name: Juniper Networks
  - name: Asterisk PBX
  description: Managed a team of 30+ developers and oversaw the management of our in house physical server infrastructure. 
               I managed a 500+ server datacenter deployment running Debian Linux, an Isilon storage cluster, F5 Networks BigIP, 
               and many other enterprise hardware offerings.  Singlesnet.com was sold to Match.com in early 2010. I was part of a team working with an investment banking firm to secure a sale.

- company: Various Companies
  position: Software Developer / Network Engineer / CTO
  timeperiod: 1999 - January 2009
  skills:
  - name: Visual Basic
  - name: Jabber/XMPP
  - name: PHP
  - name: MySQL
  - name: Linux (Debian)
  - name: C/C++
  - name: Objective-C
  - name: Shell scripting / dsh
  - name: Postfix
  - name: Nagios + Cacti
  - name: heartbeat
  - name: IPTables
  - name: F5 Networks BigIP
  - name: Asterisk PBX
  description: I started my professional career with a Windows Jabber (XMPP) client called Rival Messenger. Rival Messenger quickly became very popular and I gained credibility as a developer.  
               I transitioned from Visual Basic development to PHP web development.
               I designed and deployed the server infrastructure for Singlesnet.com, an eventual physical deployment of 500+ servers that required knowledge of linux scalability and high availability. 
               During the period of Singlesnet.com growth, we migrated datacenters to cut expenses with zero visible downtime to our users.  I scaled email delivery and built an in-house CDN. 
               Based on this work, we presented at a MySQL conference our findings for storage engine performance using upcoming storage technologies.

# skill level goes 0 to 100
skills:
- name: Project Management
  level: 96
- name: Go
  level: 90
- name: VueJS
  level: 100
- name: Python
  level: 85
- name: Infrastructure as Code
  level: 80
- name: Linux (Debian/Ubuntu)
  level: 99
- name: Yocto/OpenEmbedded
  level: 80
- name: Network Administration
  level: 100
- name: PHP/HTML5/CSS3
  level: 100
- name: Javascript (ES6)
  level: 100
- name: 3D Printing / CNC Machining
  level: 98
- name: Autodesk Fusion 360
  level: 80
- name: Raspberry Pi / Arduino
  level: 99
- name: Kubernetes
  level: 88
- name: Docker
  level: 90
- name: Objective-C
  level: 90
- name: Deep Learning (RCNN)
  level: 70
- name: VOIP/SIP
  level: 85

knowledge: I love to build things! 3D printing and CNC machining provide me with a way to build tangible things. 
           Software development and engaging open source communities help me build new relationships and skills.
           Combining innovative and useful software with tangible devices is the future, and that is what I enjoy most!

projectsummary: I create Raspberry Pi projects specifically aimed at education (STEAM) and other practical applications for low cost computing. My talkiepi project has been featured on many blogs and in print magazines. 
                My Dirt Rally Carcade project went viral, with millions of views. I recently designed and built a large format cartesian style 3D printer and am currently working on a large format delta style 3D printer (1.8 meters tall).  
                I have a fully equiped workshop with a small CNC router that allows me to machine aluminum parts for my projects.

projects:
- project: talkiepi
  name: talkiepi
  image: http://projectable.me/content/images/2016/09/IMG_8925-1.JPG
  completed: Completed September 2016
  description: talkiepi is a wifi walkie-talkie for kids and their friends. I designed the enclosure using Fusion360 and I wrote the software in Go.
  url: http://projectable.me/i-built-a-wifi-walkie-talkie-for-my-kids-now-you-can-too/
- project: carcade
  name: Dirt Rally Carcade
  image: http://projectable.me/content/images/2017/11/IMG_3182.jpg
  completed: Completed November 2017
  description: I designed and built a tabletop "carcade" from scratch using Fusion360 and 3D printing. The unit is powered by a tiny Intel motherboard/CPU combo and runs SteamOS.
  url: http://projectable.me/my-dirt-rally-tabletop-car-cade-game/
- project: simracing
  name: Sim Racing VR Motion Rig
  image: http://projectable.me/content/images/2017/12/IMG_3348-1.JPG
  completed: Completed June 2017
  description: I designed a 3DOF motion platform that was cheaper, smaller, and more flexible than the commercial offerings. 
               Built using 80/20 extrusion and aluminum brackets that I designed in Fusion360 and machined myself.
  url: http://projectable.me/my-sim-racing-motion-rig-version-2/
- project: gpuserver
  name: Cheap 1U GPU server
  image: http://projectable.me/content/images/2017/04/IMG_0512.JPG
  completed: Completed April 2017
  description: I designed a cost effective, scalable GPU server platform for BrandYourself, Inc.'s upcoming deep learning powered technologies.
  url: http://projectable.me/msi-gtx-1050ti-4g-oc-the-poor-mans-1u-inference-gpu/
- project: cncetc
  name: CNC and 3D Printers
  image: http://projectable.me/content/images/2017/06/IMG_1020.jpg
  completed: Completed March 2017
  description: I built a 3HP tabletop CNC using open source hardware and software. I then used the CNC to build large format 3D printers.
  url: http://projectable.me/status-update-20170323/
  

contact:
  email: daniel@chote.net
  phone: 
    formatted: (617) 759-4949
    unformatted: +16177594949
  city: State College, PA
  website: projectable.me
  github: dchote
  linkedin: dchote
  twitter: dchote
  mastodon: https://federatable.com/@dchote

`



//////////////////
// WEBPACK FOOTER
// ./resume/data.yml
// module id = null
// module chunks = 